export const LIST = "EVENT_QNA_BET_LIST";